import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './CustomerFailedTapPage.css';
import logo from '../../../shared/assets/images/logo.png';
import rewardData from '../../../Exampledata/rewardData.json';

const CustomerFailedTapPage = () => {
  const navigate = useNavigate();
  const [transform, setTransform] = useState('');
  const [shadow, setShadow] = useState('');
  const [isPressed, setIsPressed] = useState(false);
  const cardRef = useRef(null);

  // Function to determine if a color is light or dark
  const isLightColor = (hex) => {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Parse RGB values
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Calculate luminance using the relative luminance formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // Return true if luminance is greater than 0.5 (light color)
    return luminance > 0.5;
  };

  // Touch-based parallax effect
  const handleTouchMove = (e) => {
    if (!cardRef.current || !isPressed) return;
    
    const rect = cardRef.current.getBoundingClientRect();
    const touch = e.touches[0];
    const x = ((touch.clientX - rect.left) / rect.width - 0.5) * 15;
    const y = ((touch.clientY - rect.top) / rect.height - 0.5) * 15;
    
    setTransform(`perspective(1000px) rotateY(${x}deg) rotateX(${-y}deg) translateZ(20px)`);
    
    // Dynamic shadow based on tilt
    const shadowX = x * 2;
    const shadowY = Math.abs(y) * 1.5 + 20;
    const shadowBlur = Math.abs(x) + Math.abs(y) + 40;
    const shadowOpacity = 0.4 + (Math.abs(x) + Math.abs(y)) * 0.02;
    
    setShadow(`
      ${-shadowX}px ${shadowY}px ${shadowBlur}px rgba(255, 163, 102, ${shadowOpacity}),
      ${-shadowX * 0.5}px ${shadowY * 0.7}px ${shadowBlur * 0.6}px rgba(0, 0, 0, 0.15),
      ${-shadowX * 0.3}px ${shadowY * 0.4}px ${shadowBlur * 0.3}px rgba(0, 0, 0, 0.1)
    `);
  };

  const handleTouchStart = (e) => {
    setIsPressed(true);
    handleTouchMove(e);
  };

  const handleTouchEnd = () => {
    setIsPressed(false);
    setTransform('perspective(1000px) rotateY(0deg) rotateX(0deg) translateZ(0px)');
    setShadow('');
  };

  // Mouse events for desktop testing
  const handleMouseDown = (e) => {
    setIsPressed(true);
    handleMouseMove(e);
  };

  const handleMouseMove = (e) => {
    if (!cardRef.current || !isPressed) return;
    
    const rect = cardRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 15;
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 15;
    
    setTransform(`perspective(1000px) rotateY(${x}deg) rotateX(${-y}deg) translateZ(20px)`);
    
    // Dynamic shadow for mouse as well
    const shadowX = x * 2;
    const shadowY = Math.abs(y) * 1.5 + 20;
    const shadowBlur = Math.abs(x) + Math.abs(y) + 40;
    const shadowOpacity = 0.4 + (Math.abs(x) + Math.abs(y)) * 0.02;
    
    setShadow(`
      ${-shadowX}px ${shadowY}px ${shadowBlur}px rgba(255, 163, 102, ${shadowOpacity}),
      ${-shadowX * 0.5}px ${shadowY * 0.7}px ${shadowBlur * 0.6}px rgba(0, 0, 0, 0.15),
      ${-shadowX * 0.3}px ${shadowY * 0.4}px ${shadowBlur * 0.3}px rgba(0, 0, 0, 0.1)
    `);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
    setTransform('perspective(1000px) rotateY(0deg) rotateX(0deg) translateZ(0px)');
    setShadow('');
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
    setTransform('perspective(1000px) rotateY(0deg) rotateX(0deg) translateZ(0px)');
    setShadow('');
  };

  const handleBounceLogoClick = () => {
    navigate('/');
  };

  const handleHomepageClick = () => {
    navigate('/');
  };

  const { color } = rewardData;
  const textColor = isLightColor(color || '#FFA366') ? '#666666' : 'white';

  return (
    <div className="customer-failed-tap-page">
      <div 
        ref={cardRef}
        className="failed-card-container"
        style={{ 
          transform: transform,
          boxShadow: shadow
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        <div className="card-inner">
          <div 
            className="card-front"
            style={{ backgroundColor: color || '#FFA366' }}
          >
            <div className="failed-message-container">
              <div className="failed-message">
                <p style={{ color: textColor }}>
                  Reward expired or tap failed.
                </p>
              </div>
              
              <button 
                className="homepage-button"
                onClick={handleHomepageClick}
                style={{ 
                  color: textColor,
                  borderColor: textColor 
                }}
              >
                Homepage
              </button>
            </div>

          </div>
        </div>
      </div>

      <div className="bounce-logo-container">
        <img 
          src={logo} 
          alt="Powered by BounceLoyalty" 
          className="bounce-logo" 
          onClick={handleBounceLogoClick}
        />
      </div>

      <div className="legal-links">
        <a href="/privacy-policy" className="legal-link">Privacy Policy</a>
        <span className="legal-separator">•</span>
        <a href="/terms-of-service" className="legal-link">Terms of Service</a>
      </div>
    </div>
  );
};

export default CustomerFailedTapPage;